module.exports = __webpack_public_path__ + "static/5-f29a6a6e071dcb71070c9dc239f8802d.jpg";